import { SVGProps } from 'react';

export default function BoxMinusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none" {...props}>
      <path
        d="M25.5143 20.0525V7.35082L14.5143 1L3.51428 7.35082V20.0525L14.5143 26.4034L25.5143 20.0525Z"
        stroke="black"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.51428 7.35107L14.5143 13.702M14.5143 13.702L25.5143 7.35107M14.5143 13.702V26.4037"
        stroke="black"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5143 19C17.2757 19 19.5143 16.7614 19.5143 14C19.5143 11.2386 17.2757 9 14.5143 9C11.7529 9 9.51428 11.2386 9.51428 14C9.51428 16.7614 11.7529 19 14.5143 19Z"
        fill="white"
        stroke="#E51C00"
        strokeMiterlimit="10"
      />
      <path d="M16.9833 13.9985H12.0454" stroke="#E51C00" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>
  );
}
